<template>
           
    <form class="overflow-hidden py-5">
   
        <div class="row">
            <div class="col-12 col-lg-4">
                <label for="" class="label">
                    Avatar <small>(optional)</small>
                </label>
                
                <img-field :model='model' 
                   :f='"avatar"' ref='img' 
                   :options='imageOptions'></img-field>

            </div>
        
            <div class="col-12 col-lg-8">

                
                <div class="input-group mt-3 mb-4">
                    <label for="email" class="label"> E-Mail: </label>
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="email-icon">
                            <span class="icon icon-mail1"></span>
                        </span>
                    </div>
                    <input id="email" type="email" v-model='model.email' class="form-control" name="email" required aria-describedby="email-icon" autocomplete="email">
                </div>
              
                <div class="input-group mb-4">
                    <label for="name" class="label"> Your name: </label>
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="name-icon">
                            <span class="icon icon-writing"></span>
                        </span>
                    </div>
                    <input id="name" type="name" v-model='model.name' class="form-control" name="name" required aria-describedby="name-icon" autocomplete="email">
                </div>
                
                <div class="input-group mb-4">
                    <label for="password" class="label"> Password: </label>
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="pass-icon">
                            <span class="icon icon-shield-copy"></span>
                        </span>
                    </div>
                    <input id="password" v-model='model.password' type="password" class="form-control" name="password" aria-describedby="pass-icon" required>
                </div>
           
                <div class="input-group mb-3">
                    <label for="password-confirm" class="label"> Password repeat: </label>
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="pass-icon-repeat">
                            <span class="icon icon-shield-copy"></span>
                        </span>
                    </div>
                    <input id="password-confirm" type="password" v-model='pwdRepeat' class="form-control" name="password_confirmation" aria-describedby="pass-icon-repeat" required autocomplete="new-password">
                </div>
            
                <div>
                    <label class="custom-checkbox text-small" for='terms'>
                        <input id="terms" v-model='terms' type="checkbox" class="custom-control-input">
                        <span class="d-inline-block mr-3">Agree with terms</span> 
                        <a href="/terms-and-conditions" class="d-inline-block" target="_blank">Read the terms</a>
                    </label>
                </div>
                    
            </div>
        </div>

        <div class="row">
             <div class="col-12 text-center mt-3">
                <form-validator ref='validator' :fields='validatorFields'></form-validator>
            </div>
        </div>

        <div class="row">
            <div class="col-12 text-center">
                <button @click='register' type='button' class="btn btn-primary btn-lg" 
                        :disabled='isLoading || !terms'>
                    <span v-if='!isLoading'>Create your account</span>
                    <img v-if='isLoading' src='/resources/loader.svg' width="32px">
                </button>
            </div>
        </div>
    </form>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
            
        },

        data() {
            var me = this;

            return {
                isReady : false,
                isLoading : false,

                terms : false,

                model : {
                    name        : '',
                    s           : null,
                    avatar      : null,
                    last_name   : '-',
                    email       : '',
                    password    : '',
                    phone       : '',
                    location    : '',
                    newsletter  : false
                },

                imageOptions : {
                    width        : 200,
                    height       : 200,
                    maxFileSize  : 2000000,
                    allowedTypes : ['image/jpeg','image/png'],
                    textTitle    : 'Profile image',
                    wrapperClass : 'place-img-wrap',
                    imageClass   : "place-image",
                    thumbnail    : false
                },

                pwdRepeat : '',


                validatorFields : [
                    { 
                        selector  : "#name",
                        minLength : 2,
                        customErr : 'Please enter your name'
                    },
                    { 
                        selector  : "#last_name",
                        minLength : 2,
                        customErr : 'Please enter your surname'
                    },
                    { 
                        selector  : "#email",
                        minLength : 2,
                        customErr : 'Please enter your email'
                    },
                    { 
                        selector  : "#password",
                        minLength : 8,
                        customErr : 'Enter at least 8 characters'
                    },
                   
                    { 
                        selector  : "#password-confirm",
                        minLength : 8,
                        sameAs    : "#password",
                        customErr : 'Enter at least 8 characters'
                    },
                   
                ],

            }
        },

        methods : {

            register : _.debounce( function() {
                var me = this;

                if( !me.terms ) {
                    return;
                }

     
                this.$refs.validator.validate({
                    resolve() {

                        me.isLoading = true;

                        var afid = localStorage.getItem('_afid');

                        if( afid ) {
                            me.model.afid = afid;
                        }

                        me.ajax.call('register', me.model , (r) => {
                            
                            me.isReady = true;

                            if( r.status == 'success' ) {

                                $.notify('Registration was successfull','success');

                                setTimeout( () => {
                                    location.href = '/';
                                },500);

                                if( afid ) {
                                    localStorage.removeItem('_afid');
                                }

                            } else {

                                me.isLoading = false;
                                $.notify( r.message, 'warning' );

                            }

                        })
                    }
                });

            },500),
        }

    }
</script>
